/**
 * External dependencies
 */
import { get, filter } from 'lodash';


export default (state, connectionId) => {
    return filter(get(state, ['locationWebsites', 'items']), { connection: connectionId });
};